import { fetchWithErrorThrowing } from 'ck-utils';

// These are standalone queries that have no corresponding hook

export const deletePoll = async (id: string) =>
  fetchWithErrorThrowing(`/polls/${id}`, {
    method: 'DELETE',
  });
